import { render, staticRenderFns } from "./PropertyCalendarItem.vue?vue&type=template&id=50e373c4&scoped=true&"
import script from "./PropertyCalendarItem.vue?vue&type=script&lang=js&"
export * from "./PropertyCalendarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e373c4",
  null
  
)

export default component.exports